import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export function initImageGalleryBlocks(root = document) {
  const sliders = root.querySelectorAll('.js-image-gallery-swiper');

  sliders.forEach((sliderEl) => {
    if (sliderEl.swiper) {
      return;
    }

    const slides = sliderEl.querySelectorAll('.swiper-slide');

    if (slides.length <= 1) {
      const paginationEl = sliderEl.querySelector('.swiper-pagination');
      if (paginationEl) {
        paginationEl.style.display = 'none';
      }
      return;
    }

    new Swiper(sliderEl, {
      modules: [Pagination],
      slidesPerView: 'auto',
      spaceBetween: 8,
      centeredSlides: false,
      grabCursor: true,
      pagination: {
        el: sliderEl.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  });
}

